export default __webpack_public_path__ + "static/media/youtube.741ec65a.svg";